// extracted by mini-css-extract-plugin
export default {"form":"so","inline":"to","inputWrapper":"uo","input":"vo","withoutLabel":"wo","error":"xo","label":"yo"};